<button (click)="handleClick()"
        climbButton
        [title]="isCustomizeWorkspaceActive() ? 'Lock Workspace' : 'Unlock Workspace'"
        [variant]="isCustomizeWorkspaceActive() ? 'warning' : 'ghost'"
        size="md">
    <svg [climbIcon]="isCustomizeWorkspaceActive() ? icons.padlockOpenedFilled : icons.padlockClosedFilled" size="sm"></svg>
</button>
